export const ops = {
    // Generic operations
    create: 'create',
    delete: 'delete',
    edit: 'edit',
    end: 'end',
    leave: 'leave',
    start: 'start',
    view: 'view',
    archive: 'archive',
    // Specific ones
    activateOption: 'activateOption',
    buy: 'buy',
    exportList: 'exportList',
    linkDevice: 'linkDevice',
    requestChargeableOption: 'requestChargeableOption',
    requestMembership: 'requestMembership',
    transferOwnership: 'transferOwnership',
    unlinkDevice: 'unlinkDevice'
};
